export const listMeteringRecords = `
   query listMeteringRecords($filter: MeteringRecordsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listMeteringRecords(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              productCode
              usageRecords {
                customerIdentifier
                dimension
                quantity
                timestamp
              }
              created
              updated
           }
           nextToken
       }
   }
`;

export const getMeteringRecord = `
   query getMeteringRecord($id:ID!) {
       getMeteringRecord(id:$id) {
         id
         productCode
        usageRecords {
            customerIdentifier
            dimension
            quantity
            timestamp
         }
         created
         updated
       } 
}`;
